import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuickLinkDataState } from './quicklink.state';

const selectQuickLinkDataState = createFeatureSelector<QuickLinkDataState>('quickLinkData');

export const selectQuickLinkData = createSelector(selectQuickLinkDataState, (state: QuickLinkDataState) => state.quickLinkData);
